module.exports = __webpack_public_path__ + "static/media/zervant-logo.252ed05e.svg";